import { typeOf } from '@ember/utils';
import Transform from 'ember-data/transform';

// Any attribute using this transform will have its dirty state checked via the
// custom RecordData extension in app/store/record-data.ts

export default class ArrayTransform extends Transform {
  deserialize(serialized: unknown) {
    if (typeOf(serialized) === 'array') {
      return serialized;
    }

    return [];
  }

  serialize(deserialized: unknown) {
    if (typeOf(deserialized) === 'array') {
      return deserialized;
    }

    return [];
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    array: any[] | null;
  }
}
